export const ROUTES = {
  EXAMPLE: "/",
};

export default ROUTES;
